import {
  getAllNotificationServices,
  markANotificationAsReadService,
  markAllNotificationsAsReadService,
  getAllUnreadNotificationServices
} from '@/services/notificationService'
/** mutation types */
const set_notificationDrawer = 'set_notificationDrawer'
const set_notifications = 'set_notifications'
const set_drawerOpenedByNotification = 'set_drawerOpenedByNotification'
const set_notificationRouteDetails = 'set_notificationRouteDetails'
const set_unreadNotifications = 'set_unreadNotifications'
/** state */
const getDefaultState = () => {
  return {
    hasNotificationDrawerOpen: false,
    drawerOpenedByNotification: false,
    transactionNotificationRouteDetails: {},
    allNotifications: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    },
    unreadNotifications: {
      items: [],
      page: {
        page: 1,
        size: 10,
        hasNextPage: false,
        hasPreviousPage: false,
        totalCount: 0
      }
    }
  }
}
const state = getDefaultState()
/** mutations */
const mutations = {
  [set_notificationDrawer] (state, data) {
    state.hasNotificationDrawerOpen = data
  },
  [set_notifications] (state, data) {
    state.allNotifications = data
  },
  [set_unreadNotifications] (state, data) {
    state.unreadNotifications = data
  },
  [set_drawerOpenedByNotification] (state, data) {
    state.drawerOpenedByNotification = data
  },
  [set_notificationRouteDetails] (state, data) {
    state.transactionNotificationRouteDetails = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  resetNotificationState ({ commit }) {
    commit('resetState')
  },
  setNotificationDrawer: ({ commit }, payload) => {
    commit('set_notificationDrawer', payload)
  },
  setDrawerOpenedByNotification: ({ commit }, payload) => {
    commit('set_drawerOpenedByNotification', payload)
  },
  getAllNotification: ({ commit }, payload) => {
    return getAllNotificationServices(payload).then((response) => {
      commit('set_notifications', response.data.data)
    })
  },
  getUnreadNotification: ({ commit }, payload) => {
    return getAllUnreadNotificationServices(payload).then((response) => {
      commit('set_unreadNotifications', response.data.data)
    })
  },
  markANotificationAsRead: ({ commit }, id) => {
    return markANotificationAsReadService(id)
  },
  markAllNotificationsAsRead: ({ commit }) => {
    return markAllNotificationsAsReadService()
  },
  notificationRouteDetails: ({ commit }, payload) => {
    commit('set_notificationRouteDetails', payload)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
